<template>
  <div>
    <Header style="background: #00101A" />
    <router-view style="padding: 90px 30px 30px" />
  </div>
</template>
<script>
import Header from '@/components/Header'
export default {
  components: { Header }
}
</script>
